import { Component, ElementRef, EventEmitter, forwardRef, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounce } from 'lodash'; 
import { ConsultasService } from '@app/services/consultas.service';

@Component({
  selector: 'app-dropdown-meilisearch',
  templateUrl: './dropdown-meilisearch.component.html',
  styleUrls: ['./dropdown-meilisearch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownMeilisearchComponent),
      multi: true
    }
  ]
})
export class DropdownMeilisearchComponent implements OnInit, OnChanges {
  @Input() clienteNome: string = '';
  @Input() items: any[] = [];
  @Output() clienteSelecionado = new EventEmitter<any>();
  @Input() customClass: string | null = null;
  @Input() allowClear: boolean = false;
  @HostListener('document:click', ['$event'])

  onClickOutside(event: MouseEvent) {
  const target = event.target as HTMLElement;
  if (!this.elementRef.nativeElement.contains(target)) {
    this.resultados = [];
  }
}

resultados: any[] = [];
filtros: any = {}; 
_debounceFn: any;
_pesquisa: string = '';
isReadonly: boolean = false;
pesquisaPorId: boolean = false;

value: any;
onChange = (_: any) => {};
onTouched = () => {};

constructor(private elementRef: ElementRef,
  private consultasService: ConsultasService) {}

  ngOnInit(): void { }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['valorInicial']?.currentValue && !changes['valorInicial'].firstChange) {
      this.consultasService.retornarParticipante(changes['valorInicial'].currentValue.toString()).subscribe(data => {
        this.clienteSelecionado.emit(data); 
      });
    }
  }

  onKeyPress(value: any) {
    this._pesquisa = value; 

    if (!this._debounceFn) {
      this._debounceFn = debounce(() => {

        const filtro = this._pesquisa;
        if (filtro.length >= 3) {
          this.consultasService.retornarParticipante(filtro).toPromise().then(data => {
          this.resultados = data; 
          });
        }
      }, 500);
    }

    this._debounceFn();
  }

  selecionar(cliente: any) {
    this._pesquisa = `${cliente.Id} - ${cliente.NomeFantasia} - ${cliente.CNPJ_CPF}`;
    this.value = cliente.Id;                
    this.onChange(this.value);                   
    this.clienteSelecionado.emit(cliente);       
    this.resultados = [];  
    this.isReadonly = true;              
  }


  writeValue(value: any): void {
    this.value = value;

    if (!value) {
      this._pesquisa = '';
      this.isReadonly = false;
      return;
    }

    this.consultasService.retornarParticipante(value).subscribe(cliente => {
    const c = Array.isArray(cliente) ? cliente[0] : cliente;

      if (c && c.Id) {
        this._pesquisa = `${c.Id} - ${c.NomeFantasia} - ${c.CNPJ_CPF} ${c.Funcionario ? (c.Ativo ? ' (Funcionário)' : ' (Funcionário inativo)') : ''}`;      
        this.isReadonly = true; 
      } else {
        this._pesquisa = '';
        this.isReadonly = false;
      }
      });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  clearPesquisa() {
    this._pesquisa = '';
    this.value = null;
    this.onChange(this.value);
    this.clienteSelecionado.emit(null);
    this.resultados = [];
    this.isReadonly = false; 
  }
}

